import {GlobalVariables} from "../GlobalVariables";

export default class Banner {
	static init() {
		const banner = document.querySelector(".banner");
		if (!banner) {
			return;
		}
		const scrollButton = banner.querySelector(".arrow-down");
		if (!scrollButton) {
			return;
		}
		const nextElement = banner.nextElementSibling;

		scrollButton.addEventListener("click", () => {
			// Add 1 pixel offset to the scroll position
			const offsetPosition = nextElement.getBoundingClientRect().top + window.pageYOffset + 2;
			window.scrollTo({
				top: offsetPosition,
				behavior: "smooth"
			});
		});
	}
}
